import styled from 'styled-components'

export const Main = styled.div`
h2{
    margin-bottom: 0.5rem;
    color: var(--a3);
}
`
